<script setup>
/**
 * Standalone Reset Password screen — mirrors Vue2's ResetPassword.vue
 * (POST /users/reset-password with { data: customer_id }).
 */
import { ref } from "vue";
import { useRouter } from "vue-router";
import { resetUserPassword } from "./api";

const router = useRouter();
const customerId = ref(""), loading = ref(false), success = ref(false), error = ref(""), errMsg = ref("");

async function submit() {
  if (!customerId.value.trim()) return;
  loading.value = true; success.value = false; error.value = ""; errMsg.value = "";
  try {
    await resetUserPassword(customerId.value.trim());
    success.value = true;
  } catch {
    error.value = true;
    errMsg.value = "Error occurred. Please try again.";
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'users' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Reset Password</h1>
    <VCard class="pa-4" max-width="480">
      <p class="mb-2">Default Password (Logged in before) - <b><i>WelcomeToAspial!</i></b></p>
      <p class="mb-4">Default Password (First time login) - Birthdate in <b><i>DDMMYYYY</i></b> + Last 4 digits of Employee ID No.</p>
      <VAlert v-if="error" type="error" class="mb-4">{{ errMsg }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">Password reset.</VAlert>
      <VTextField v-model="customerId" label="Employee Number" class="mb-4" @keyup.enter="submit" />
      <VBtn :loading="loading" :disabled="!customerId.trim()" @click="submit">Reset</VBtn>
    </VCard>
  </section>
</template>
